import React from 'react';

export default function NoAccessMsg() {
  return (<div className='mt-2'>Your user Role does not have access to this section</div>)
}
